'use strict'; // Port of lower_bound from http://en.cppreference.com/w/cpp/algorithm/lower_bound
// Used to compute insertion index to keep queue sorted after insertion

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function lowerBound(array, value, comp) {
  var first = 0;
  var count = array.length;

  while (count > 0) {
    var step = count / 2 | 0;
    var it = first + step;

    if (comp(array[it], value) <= 0) {
      first = ++it;
      count -= step + 1;
    } else {
      count = step;
    }
  }

  return first;
}

var PriorityQueue =
/*#__PURE__*/
function () {
  function PriorityQueue() {
    _classCallCheck(this, PriorityQueue);

    this._queue = [];
  }

  _createClass(PriorityQueue, [{
    key: "enqueue",
    value: function enqueue(run, opts) {
      opts = Object.assign({
        priority: 0
      }, opts);
      var element = {
        priority: opts.priority,
        run: run
      };

      if (this.size && this._queue[this.size - 1].priority >= opts.priority) {
        this._queue.push(element);

        return;
      }

      var index = lowerBound(this._queue, element, function (a, b) {
        return b.priority - a.priority;
      });

      this._queue.splice(index, 0, element);
    }
  }, {
    key: "dequeue",
    value: function dequeue() {
      return this._queue.shift().run;
    }
  }, {
    key: "size",
    get: function get() {
      return this._queue.length;
    }
  }]);

  return PriorityQueue;
}();

var PQueue =
/*#__PURE__*/
function () {
  function PQueue(opts) {
    _classCallCheck(this, PQueue);

    opts = Object.assign({
      concurrency: Infinity,
      autoStart: true,
      queueClass: PriorityQueue
    }, opts);

    if (!(typeof opts.concurrency === 'number' && opts.concurrency >= 1)) {
      throw new TypeError("Expected `concurrency` to be a number from 1 and up, got `".concat(opts.concurrency, "` (").concat(typeof opts.concurrency, ")"));
    }

    this.queue = new opts.queueClass(); // eslint-disable-line new-cap

    this._queueClass = opts.queueClass;
    this._pendingCount = 0;
    this._concurrency = opts.concurrency;
    this._isPaused = opts.autoStart === false;

    this._resolveEmpty = function () {};

    this._resolveIdle = function () {};
  }

  _createClass(PQueue, [{
    key: "_next",
    value: function _next() {
      this._pendingCount--;

      if (this.queue.size > 0) {
        if (!this._isPaused) {
          this.queue.dequeue()();
        }
      } else {
        this._resolveEmpty();

        this._resolveEmpty = function () {};

        if (this._pendingCount === 0) {
          this._resolveIdle();

          this._resolveIdle = function () {};
        }
      }
    }
  }, {
    key: "add",
    value: function add(fn, opts) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var run = function run() {
          _this._pendingCount++;

          try {
            Promise.resolve(fn()).then(function (val) {
              resolve(val);

              _this._next();
            }, function (err) {
              reject(err);

              _this._next();
            });
          } catch (err) {
            reject(err);

            _this._next();
          }
        };

        if (!_this._isPaused && _this._pendingCount < _this._concurrency) {
          run();
        } else {
          _this.queue.enqueue(run, opts);
        }
      });
    }
  }, {
    key: "addAll",
    value: function addAll(fns, opts) {
      var _this2 = this;

      return Promise.all(fns.map(function (fn) {
        return _this2.add(fn, opts);
      }));
    }
  }, {
    key: "start",
    value: function start() {
      if (!this._isPaused) {
        return;
      }

      this._isPaused = false;

      while (this.queue.size > 0 && this._pendingCount < this._concurrency) {
        this.queue.dequeue()();
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this._isPaused = true;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.queue = new this._queueClass(); // eslint-disable-line new-cap
    }
  }, {
    key: "onEmpty",
    value: function onEmpty() {
      var _this3 = this;

      // Instantly resolve if the queue is empty
      if (this.queue.size === 0) {
        return Promise.resolve();
      }

      return new Promise(function (resolve) {
        var existingResolve = _this3._resolveEmpty;

        _this3._resolveEmpty = function () {
          existingResolve();
          resolve();
        };
      });
    }
  }, {
    key: "onIdle",
    value: function onIdle() {
      var _this4 = this;

      // Instantly resolve if none pending
      if (this._pendingCount === 0) {
        return Promise.resolve();
      }

      return new Promise(function (resolve) {
        var existingResolve = _this4._resolveIdle;

        _this4._resolveIdle = function () {
          existingResolve();
          resolve();
        };
      });
    }
  }, {
    key: "size",
    get: function get() {
      return this.queue.size;
    }
  }, {
    key: "pending",
    get: function get() {
      return this._pendingCount;
    }
  }, {
    key: "isPaused",
    get: function get() {
      return this._isPaused;
    }
  }]);

  return PQueue;
}();

module.exports = PQueue;